class dialog {
  constructor() {
    this.customDialog = null
    // this.customDialogTop = null
    // this.custonDialogTitle = null
    this.customDialogIconBox = null
    this.customDialogIcon = null
    this.customDialogContentBox = null
    this.customDialogContent = null
    // this.customSureButton = null
    // this.customCancleButton = null
  }

  static show(icon, content, color) {
    this.customDialog = document.createElement('div')
    this.customDialog.id = 'custom-dialog-box'
    // this.customDialogTop = document.createElement('div')
    // this.customDialogTop.id = 'custom-dialog-top'
    // this.custonDialogTopTitle = document.createElement('h2')
    // this.custonDialogTopTitle.id = 'custom-dialog-top-title'
    // this.custonDialogTopTitle.innerText = this.title
    this.customDialogContentBox = document.createElement('div')
    this.customDialogContentBox.id = 'custom-dialog-content-box'
    this.customDialogContent = document.createElement('div')
    this.customDialogContent.id = 'custom-dialog-content'
    this.customDialogContent.innerText = content
    this.customDialogIconBox = document.createElement('div')
    this.customDialogIconBox.id = 'custom-dialog-icon-box'
    this.customDialogIcon = document.createElement('i')
    this.customDialogIcon.id = 'custom-dialog-icon'
    this.customDialogIcon.setAttribute('class', 'iconfont ' + icon)
    this.customDialogIcon.style.color = color
    // this.customSureButton = document.createElement('span')
    // this.customSureButton.id = 'custom-dialog-sure-button'
    // this.customCancleButton = document.createElement('span')
    // this.customCancleButton.id = 'custom-dialog-cancle-button'
    document.body.appendChild(this.customDialog)
    // document.getElementById('custom-dialog-box').appendChild(this.customDialogTop)
    // document.getElementById('custom-dialog-top').appendChild(this.custonDialogTopTitle)
    document.getElementById('custom-dialog-box').appendChild(this.customDialogContentBox)
    document.getElementById('custom-dialog-content-box').appendChild(this.customDialogIconBox)
    document.getElementById('custom-dialog-icon-box').appendChild(this.customDialogIcon)
    document.getElementById('custom-dialog-content-box').appendChild(this.customDialogContent)
    // document.getElementById('custom-dialog-button-box').appendChild(this.customSureButton)
    // document.getElementById('custom-dialog-button-box').appendChild(this.customCancleButton)
    setTimeout(() => {
      document.body.removeChild(document.getElementById('custom-dialog-box'))
    }, 800)
  }

  // 确认框
  static confirm(boxTitle, contextText, callbackFun = null, cancelcallback = null) {
    this.customDialog = document.createElement('div');
    this.customDialog.className = 'confirm-box';

    const maskContainer = document.createElement('div');
    maskContainer.className = 'mask-container';

    this.customDialogContentBox = document.createElement('div');
    this.customDialogContentBox.className = 'context-box';

    this.customDialogContent = document.createElement('div');
    this.customDialogContent.className = 'context-head';

    this.customDialogContent.onmouseenter = ()=>{
      this.customDialogContent.style.cursor = 'move';
    }

    this.customDialogContent.onmouseleave = ()=>{
      this.customDialogContent.style.cursor = 'auto';
    }

    this.customDialogContent.onmousedown = (e)=> {
      // 获取鼠标点击弹窗的位置
      let [divX, divY] = [e.layerX, e.layerY];
      // 获取最大宽、高
      let [mostX, mostY] = [
        maskContainer.getBoundingClientRect().width - this.customDialogContentBox.getBoundingClientRect().width ,
        maskContainer.getBoundingClientRect().height - this.customDialogContentBox.getBoundingClientRect().height
      ];
      // // 鼠标移动事件
      maskContainer.onmousemove = ev => {
        let oevent = ev || event;

        let X = (oevent.clientX - maskContainer.getBoundingClientRect().left - divX);
        let Y = (oevent.clientY - maskContainer.getBoundingClientRect().top - divY);

        this.customDialogContentBox.style.left = (X > 0 ? X > mostX ? mostX : X : 0) + 'px';
        this.customDialogContentBox.style.top = (Y > 0 ? Y > mostY ? mostY : Y : 0) + 'px';
      }
      // 取消绑定
      document.onmouseup = () => {
        maskContainer.onmousemove = null;
        document.onmouseup = null;
      }
    }

    const oSpan1 = document.createElement('span');
    oSpan1.innerHTML = boxTitle;
    const oSpan2 = document.createElement('span');
    oSpan2.innerHTML = 'x';
    oSpan2.className = 'box-close';
    oSpan2.onclick = () => {
      document.body.removeChild(document.querySelector(".confirm-box"));
      cancelcallback && cancelcallback();
    }

    const contextBody = document.createElement('div');
    contextBody.className = 'context-body';

    const contextBox = document.createElement('div');
    contextBox.className = 'context-container';

    const iconBox = document.createElement('div');
    iconBox.className = 'icon-box';
    this.customDialogIcon = document.createElement('i')
    this.customDialogIcon.setAttribute('class', 'iconfont ' + 'icon-smile');

    const context = document.createElement('p');
    context.className = 'context-p';
    context.innerHTML = contextText;

    const buttonBox = document.createElement('div');
    buttonBox.className = 'button-box';
    const buttonSure = document.createElement('input');
    buttonSure.value = '确定';
    buttonSure.type = 'button';
    buttonSure.onclick = () => {
      oSpan2.onclick();
      callbackFun && callbackFun();
    };

    document.body.appendChild(this.customDialog);
    this.customDialog.appendChild(maskContainer);
    this.customDialog.appendChild(this.customDialogContentBox);
    this.customDialogContentBox.appendChild(this.customDialogContent);

    this.customDialogContent.appendChild(oSpan1);
    this.customDialogContent.appendChild(oSpan2);

    this.customDialogContentBox.appendChild(contextBody);

    contextBody.appendChild(contextBox);
    contextBody.appendChild(buttonBox);

    contextBox.appendChild(iconBox);
    contextBox.appendChild(context);
    buttonBox.appendChild(buttonSure);

    iconBox.appendChild(this.customDialogIcon);
  }

  static close() {
    document.removeChild(this.customDialog);
  }
}

export default dialog
